import { Editor, Transforms } from "slate";
import { ReactEditor } from "slate-react";
import { CustomElement } from "../slate";

export const clearBlock = (editor: Editor) => {
  if (isList(editor)) {
    Transforms.unwrapNodes(editor, {
      match: (n: CustomElement | any) => LIST_FORMATS.includes(n.type),
      split: true,
    });
  }
  Transforms.setNodes(
    editor,
    { type: "paragraph" },
    { match: (n: any) => Editor.isBlock(editor, n) && n.type === "list-item" }
  );
};

const LIST_FORMATS = ["ordered-list", "unordered-list"];
type LIST_TYPES = "ordered-list" | "unordered-list";

export const isList = (editor: Editor, format?: LIST_TYPES) => {
  const [match]: any = Editor.nodes(editor, {
    match: (n: CustomElement | any) =>
      format ? n.type === format : LIST_FORMATS.includes(n.type),
  });
  return !!match;
};
/**
 * @description Wraps the block with a h2 tag.
 *
 * @param {CustomEditor} editor
 * @param {LIST_TYPES} format
 */
export const toggleList = (editor: Editor, format: LIST_TYPES) => {
  const isSameListActive = isList(editor, format);
  if (isSameListActive) {
    Transforms.unwrapNodes(editor, {
      match: (n: CustomElement | any) => LIST_FORMATS.includes(n.type),
      split: true,
    });

    clearBlock(editor);
  } else {
    Transforms.unwrapNodes(editor, {
      match: (n: CustomElement | any) => LIST_FORMATS.includes(n.type),
      split: true,
    });

    Transforms.setNodes(editor, {
      type: "list-item",
    });

    Transforms.wrapNodes(editor, { type: format, children: [] });
  }
  ReactEditor.focus(editor);
};

export const isBlock = (editor: Editor) => {
  const [match]: any = Editor.nodes(editor, {
    match: (n: CustomElement | any) => Editor.isBlock(editor, n),
  });
  return !!match;
};

export const isRemovableBlock = (editor: Editor) => {
  const removableBlockTypes = [
    "block-quote",
    "code-block",
    "list-item",
    "ordered-list",
    "unordered-list",
  ];
  const isEmpty = (children: any) => {
    return Boolean(
      !children ||
        children?.length === 0 ||
        (children?.length === 1 &&
          !children[0].text &&
          !children[0].children?.length)
    );
  };
  const isMatchType = (n: CustomElement) => {
    return (
      removableBlockTypes.includes(n.type) ||
      (n.type === "heading" && n.level === 1)
    );
  };
  const [match]: any = Editor.nodes(editor, {
    match: (n: CustomElement | any) => {
      return Editor.isBlock(editor, n) && isEmpty(n.children) && isMatchType(n);
    },
  });
  return !!match;
};

export const insertSoftBreak = (editor: Editor) => {
  Transforms.insertText(editor, "\n");
};
